define([
	"dojo/_base/declare",
	"csi/gallery/Delete",
	"csi/locale"
], function(declare,DeleteController,locale) {

	return declare(DeleteController, {
		// Boolean: indicates that action works on view refNode
		bRefNode: true,

		confirmAction: function(/*Object*/params) {
			// summary: prompt user for response
			params.message = locale.resource("DeleteCommentConfirmMessage");

			this.inherited(arguments);
		}
	});


});